import { useState } from 'react';
import { api } from '../../api/api';

interface CreateGiveawayAssetModalProps {
  isOpen: boolean;
  onClose: () => void;
  onCreate: (newAsset: any) => void;
}

const CreateGiveawayAssetModal = ({ isOpen, onClose, onCreate }: CreateGiveawayAssetModalProps) => {
  const [newAsset, setNewAsset] = useState({
    name: '',
    description: '',
    image_path: '',
    price: 0,
    category: '',
    reward_id: '',
    status: 'notclaimed',
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setNewAsset(prev => ({ ...prev, [name]: value }));
  };

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      const formData = new FormData();
      formData.append('file', file);

      try {
        const response = await api.post('/api/files/upload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        setNewAsset(prev => ({ ...prev, image_path: response.data.filename }));
      } catch (error) {
        console.error('Failed to upload file', error);
      }
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onCreate({ ...newAsset, price: parseFloat(newAsset.price as any) });
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-1000">
      <div className="gothic-panel w-full max-w-md">
        <h2 className="gothic-heading">Create New Giveaway Asset</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="name" className="block gothic-text-silver mb-1">Name</label>
            <input
              id="name"
              name="name"
              type="text"
              value={newAsset.name}
              onChange={handleChange}
              className="gothic-input w-full"
              required
            />
          </div>
          <div>
            <label htmlFor="description" className="block gothic-text-silver mb-1">Description</label>
            <textarea
              id="description"
              name="description"
              value={newAsset.description}
              onChange={handleChange}
              className="gothic-input w-full"
              rows={3}
            ></textarea>
          </div>
          <div>
            <label htmlFor="image" className="block gothic-text-silver mb-1">Image</label>
            <input
              id="image"
              name="image"
              type="file"
              onChange={handleFileChange}
              className="gothic-input w-full"
            />
            {newAsset.image_path && (
              <img
                src={`${process.env.REACT_APP_API_URL}/api/files/${newAsset.image_path}`}
                alt="Asset Preview"
                className="w-full h-auto mt-2 rounded"
              />
            )}
          </div>
          <div>
            <label htmlFor="price" className="block gothic-text-silver mb-1">Price</label>
            <input
              id="price"
              name="price"
              type="number"
              value={newAsset.price}
              onChange={handleChange}
              className="gothic-input w-full"
              required
            />
          </div>
          <div>
            <label htmlFor="category" className="block gothic-text-silver mb-1">Category</label>
            <input
              id="category"
              name="category"
              type="text"
              value={newAsset.category}
              onChange={handleChange}
              className="gothic-input w-full"
            />
          </div>
          <div>
            <label htmlFor="reward_id" className="block gothic-text-silver mb-1">Reward ID</label>
            <input
              id="reward_id"
              name="reward_id"
              type="text"
              value={newAsset.reward_id}
              onChange={handleChange}
              className="gothic-input w-full"
            />
          </div>
          <div>
            <label htmlFor="status" className="block gothic-text-silver mb-1">Status</label>
            <select
              id="status"
              name="status"
              value={newAsset.status}
              onChange={handleChange}
              className="gothic-input w-full"
            >
              <option value="notclaimed">Not Claimed</option>
              <option value="issuedtomarketors">Issued to Marketors</option>
              <option value="claimed">Claimed</option>
            </select>
          </div>
          <div className="flex justify-end gap-4">
            <button type="button" onClick={onClose} className="gothic-button">Cancel</button>
            <button type="submit" className="gothic-button gothic-button-primary">Create</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateGiveawayAssetModal;